import { CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule } from '@angular/core';
import { CrmBoardComponent } from './crm-board/crm-board.component';
import { CrmStartComponent } from './crm-start/crm-start.component';
import { CrmSearchComponent } from './crm-search/crm-search.component';
import { CrmAddressChangeDialogComponent } from './dialogs/crm-address-change-dialog/crm-address-change-dialog.component';
import { CrmNewTpslDialogComponent } from './dialogs/crm-new-tpsl-dialog/crm-new-tpsl-dialog.component';
import { CrmDriverDialogComponent } from './dialogs/crm-driver-dialog/crm-driver-dialog.component';
import { CrmAddExceptionDialogComponent } from './dialogs/crm-add-exception-dialog/crm-add-exception-dialog.component';
import { CrmShowPhotosDialogComponent } from './dialogs/crm-show-photos-dialog/crm-show-photos-dialog.component';
import { HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MatTableModule } from '@angular/material';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AngularMaterialModule } from '../../../angular-material.module';
import { createTranslateLoader, SharedModule } from '../../../shared.module';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { CrmSendPodDialogComponent } from './dialogs/crm-send-pod-dialog/crm-send-pod-dialog.component';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { CrmClientLookupDialogComponent } from './dialogs/crm-client-lookup-dialog/crm-client-lookup-dialog.component';
import { CrmRoutesComponent } from './crm-routes/crm-routes.component';
import { CrmNavbarComponent } from './crm-navbar/crm-navbar.component';
import { CrmCreateShipmentComponent } from './crm-create-shipment/crm-create-shipment.component';
import { CrmUpdateShipmentDialogComponent } from './dialogs/crm-update-shipment-dialog/crm-update-shipment-dialog.component';

// the second parameter 'fr' is optional
registerLocaleData(localeFr, 'fr');

@NgModule({
  declarations: [
    CrmBoardComponent,
    CrmStartComponent,
    CrmSearchComponent,
    CrmAddressChangeDialogComponent,
    CrmNewTpslDialogComponent,
    CrmDriverDialogComponent,
    CrmAddExceptionDialogComponent,
    CrmShowPhotosDialogComponent,
    CrmSendPodDialogComponent,
    CrmClientLookupDialogComponent,
    CrmUpdateShipmentDialogComponent,
    CrmRoutesComponent,
    CrmNavbarComponent,
    CrmCreateShipmentComponent
  ],
  entryComponents: [
    CrmAddressChangeDialogComponent,
    CrmNewTpslDialogComponent,
    CrmDriverDialogComponent,
    CrmAddExceptionDialogComponent,
    CrmShowPhotosDialogComponent,
    CrmUpdateShipmentDialogComponent,
    CrmSendPodDialogComponent,
    CrmClientLookupDialogComponent
  ],
  imports: [
    MatTableModule,
    SharedModule,
    AngularMaterialModule,
    FormsModule,
    RouterModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    })
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [{ provide: LOCALE_ID, useValue: 'fr-CA' }]
})
export class CrmModule {}
